"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppContext = exports.AppContextProvider = exports.AppContext = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _constantsGenerated = require("../constants-generated");
var _useCustomerId = require("../hooks/useCustomerId");
var _useDialogProps = require("../hooks/useDialogProps");
var _queriesNet = require("../queries-net");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore next @preserve */
const defaultSubscribe = async () => ({});
/* istanbul ignore next @preserve */
const defaultClose = () => undefined;
const AppContext = exports.AppContext = /*#__PURE__*/(0, _react.createContext)({
  config: undefined,
  loading: true,
  open: false,
  productCode: '',
  customerId: _auth.NOT_LOGGED_IN_USER_ID,
  close: defaultClose,
  subscribe: defaultSubscribe,
  successClose: defaultClose
});
const AppContextProvider = ({
  children,
  open,
  onClose,
  onOpen,
  initialOpenDone
}) => {
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    token
  } = (0, _auth.useToken)();
  const {
    customerId,
    loading: customerIdLoading
  } = (0, _useCustomerId.useCustomerId)({
    shouldLoadContext: initialOpenDone
  });
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    productCode,
    successClose
  } = (0, _useDialogProps.useDialogProps)({
    onClose,
    onOpen,
    open
  });
  const subscribe = (0, _react.useCallback)(async input => (0, _fetching.fetchGraphql)({
    query: _queriesNet.subscribeToBackInStockNotification,
    url: graphQlNetUrl,
    headers: (0, _fetching.getHeaders)({
      customerId,
      language,
      sourceAppName: _constantsGenerated.PACKAGE_NAME,
      tenant,
      token
    }),
    variables: {
      input
    }
  }), [customerId, graphQlNetUrl, language, tenant, token]);
  const {
    data,
    error
  } = (0, _staticApiClientReact.useGetTenantBackInStockNotificationsConfiguration)(tenant, {
    lang: language
  }, {
    swr: {
      enabled: open,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false
    }
  });
  const loading = (0, _react.useMemo)(() => data === undefined && error === undefined || customerIdLoading, [data, error, customerIdLoading]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AppContext.Provider, {
    value: (0, _react.useMemo)(() => ({
      config: data,
      loading,
      open,
      productCode,
      close: onClose,
      subscribe,
      successClose,
      customerId
    }), [data, loading, onClose, open, productCode, subscribe, successClose, customerId]),
    children: children
  });
};
exports.AppContextProvider = AppContextProvider;
const useAppContext = () => (0, _react.useContext)(AppContext);
exports.useAppContext = useAppContext;